import { Guides } from "./components/guides.js";
import { OldBrowserChecker } from "./components/oldBrowserChecker.js";
import { Howl } from "howler";
import "media-chrome";
import "vimeo-video-element";
import "youtube-video-element";

/* -------------------------------------------------- */
/* 🙂 General */
/* -------------------------------------------------- */

const isReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
const isDesktop = window.matchMedia("(max-width: 1000px)");

/* -------------------------------------------------- */
/* 👵 Check for old browsers */
/* -------------------------------------------------- */

new OldBrowserChecker();

/* -------------------------------------------------- */
/* 📏 Guides */
/* -------------------------------------------------- */

new Guides();

/* -------------------------------------------------- */
/* 🧑‍🎤 Musician sound buttons */
/* -------------------------------------------------- */

const soundButtons = document.querySelectorAll(".sound-button");
let currentlyPlaying = null; // Track the currently playing sound

soundButtons.forEach((button) => {
  const sound = new Howl({
    src: [button.dataset.sound],
    html5: true,
  });

  button.addEventListener("click", () => {
    // If this sound is already playing, stop it
    if (sound.playing()) {
      sound.stop();
      button.setAttribute("aria-pressed", "false");
      currentlyPlaying = null;
    } else {
      // Stop any other playing sound
      if (currentlyPlaying) {
        currentlyPlaying.sound.stop();
        currentlyPlaying.button.setAttribute("aria-pressed", "false");
      }

      // Play the new sound
      sound.play();
      currentlyPlaying = { sound, button };
    }
  });

  sound.on("play", function () {
    button.setAttribute("aria-pressed", "true");
  });

  sound.on("end", function () {
    button.setAttribute("aria-pressed", "false");
    currentlyPlaying = null;
  });
});

/* -------------------------------------------------- */
/* 🌐 Language menu */
/* -------------------------------------------------- */

const languageMenus = document.querySelectorAll(".language-menu");

languageMenus.forEach((languageMenu) => {
  const languageSelect = languageMenu.querySelector("select");

  languageSelect.addEventListener("change", () => {
    window.location.href =
      languageSelect.options[languageSelect.selectedIndex].value;
  });
});

/* -------------------------------------------------- */
/* 📱 Mobile menu */
/* -------------------------------------------------- */

const menuToggle = document.querySelector(".menu-toggle");

if (menuToggle) {
  const menuOverlay = document.querySelector(".menu-overlay"); // native dialog element
  const closeMenuButton = menuOverlay.querySelector(
    ".menu-overlay__close-button"
  );

  menuToggle.addEventListener("click", () => {
    menuOverlay.showModal();
  });

  closeMenuButton.addEventListener("click", () => {
    menuOverlay.close();
  });

  // Once desktop media query no longer matches, close the menu
  isDesktop.addEventListener("change", (e) => {
    if (!e.matches) {
      menuOverlay.close();
    }
  });
}

/* -------------------------------------------------- */
/* ↩️ Intelligent back link */
/* -------------------------------------------------- */

let backLinks = document.querySelectorAll(".back-link");

backLinks.forEach((backLink) => {
  backLink.addEventListener("click", function (e) {
    const previousPage = document.referrer;
    const currentDomain = window.location.hostname;

    if (previousPage && previousPage.includes(currentDomain)) {
      e.preventDefault();
      window.history.back();
    }
  });
});

// --------------------------------------------------
// 🍪 Cookie Consent
// --------------------------------------------------

function setVideoSources() {
  const videos = document.querySelectorAll("youtube-video, vimeo-video");
  videos.forEach((video) => {
    if (video.dataset.src) {
      video.setAttribute("src", video.dataset.src);
      video.removeAttribute("data-src");
    }
  });
}

function handleConsent() {
  document.documentElement.dataset.consent = "true";
  setVideoSources();
}

// Event listeners for consent buttons
document.querySelectorAll(".gdpr-hint__button").forEach((button) => {
  button.addEventListener("click", (e) => {
    handleConsent();
    e.preventDefault();
  });
});
